import React from 'react'
import { CalendarCheck, StopCircleFill } from 'react-bootstrap-icons'
import PortalKebabMenu from './PortalKebabMenu'
import { isTimelineEndDatePassed } from '../../../utils/timelineAssetDates'

export default function ProjectTimelineAssetItem({ timelineAsset, isTemporary, menuItems }) {
  const hasMenu = menuItems?.length > 0
  const accentColor = timelineAsset.theme_color || '#50d47f'
  const isPassed = isTimelineEndDatePassed(timelineAsset.end_date)
  const ProjectIcon = isPassed ? CalendarCheck : StopCircleFill

  return (
    <div
      className={`
        flex h-full w-full items-center overflow-hidden rounded-md border-l-2 px-2 py-1
        text-left
        ${hasMenu ? 'justify-between' : ''}
        ${isTemporary ? 'opacity-70' : ''}
        ${
          isPassed
            ? 'bg-gray-100 opacity-75 shadow-none grayscale dark:bg-rb-dark-mode-lighter/60'
            : 'bg-white shadow-sm dark:bg-rb-dark-mode-lighter'
        }
      `}
      style={{
        left: 0,
        right: 0,
        zIndex: 1,
        minWidth: 0,
        borderLeftColor: accentColor,
      }}
    >
      <div className="flex min-w-0 flex-1 items-center gap-1">
        <ProjectIcon
          style={isPassed ? undefined : { color: accentColor }}
          className={`shrink-0 text-sm ${isPassed ? 'text-rb-lighter-grey dark:text-gray-400' : ''}`}
        />
        <h4
          className={`min-w-0 flex-1 truncate text-xs font-medium text-rb-black dark:text-white ${
            isPassed ? 'text-rb-lighter-grey dark:text-gray-400' : ''
          }`}
          title={timelineAsset.name}
        >
          {timelineAsset.name}
        </h4>
      </div>
      {hasMenu && (
        <PortalKebabMenu
          items={menuItems}
          ariaLabel="Open project asset menu"
          buttonClassName="ml-1 rounded p-0.5 text-rb-black hover:bg-gray-100 dark:text-white dark:hover:bg-rb-dark-mode"
        />
      )}
    </div>
  )
}
